module.exports = __webpack_public_path__ + "img/switzerland-logo-icon.48917e61.png";